import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=08b975bf&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=08b975bf&prod&lang=less"
import style1 from "./Home.vue?vue&type=style&index=1&id=08b975bf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b975bf",
  null
  
)

export default component.exports